import { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { toast } from 'react-toastify';
import appConfig from '../../../../config/app-config';

export const useInternalManagers = () => {
    const [managers, setManagers] = useState<Array<{ value: string; label: string }>>([]);

    useEffect(() => {
        const fetchManagers = async () => {
            try {
                const { address, key } = appConfig.apis.personApiEnv;
                const token = (await Auth.currentSession()).getIdToken().getJwtToken();
                const res = await fetch(`${address}/legal-persons/internal-managers`, {
                    headers: { 'x-api-key': key, 'Authorization': `Bearer ${token}` },
                });
                const data = await res.json();
                const sorted = (data.list || [])
                    .filter((name: unknown) => typeof name === 'string' && name.trim())
                    .sort((a: string, b: string) => a.localeCompare(b, 'pt-BR'))
                    .map((name: string) => ({ value: name, label: name }));
                setManagers(sorted);
            } catch (error: unknown) {
                console.error('Erro ao buscar traders:', error);
                toast.error('Erro ao carregar lista de traders.');
            }
        };
        fetchManagers();
    }, []);

    return managers;
};
